import { render, staticRenderFns } from "./to-do-app.vue?vue&type=template&id=d15ab72a&scoped=true"
import script from "./to-do-app.vue?vue&type=script&lang=js"
export * from "./to-do-app.vue?vue&type=script&lang=js"
import style0 from "./to-do-app.vue?vue&type=style&index=0&id=d15ab72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15ab72a",
  null
  
)

export default component.exports